import { makeStyles, Card, Grid } from '@material-ui/core';
import CreateJoinCard from './CreateJoinCard';
import JoinCardsList from './JoinCardsList';
import BackButton from './BackButton';
import CreateDataSpaceButton from '../ui_components/CreateDataSpaceButton';
import NewDataSpacePageContentWrapper from '../ui_components/NewDataSpacePageContentWrapper';
import { useContext, useEffect } from 'react';
import { trackEvent } from '../../../../utils/eventTracking';
import { UserProfileContext } from '../../../../UserProfileContext';

// Join page of new dataspace form.
const DatasetJoinNew = () => {
	const userProfile = useContext(UserProfileContext)[0];

	useEffect(() => {
		trackEvent({
			userDetails: { userId: userProfile._id, email: userProfile.email },
			eventDetails: {
				types: ['KissMetrics', 'Segment', 'Encharge', 'GA4', 'AppInsights'],
				eventName: 'WebApp_User Visits Join Page In Edit DataSpace Form',
			},
		});
	}, []);

	return (
		<NewDataSpacePageContentWrapper header="Join Your DataSources">
			<CreateJoinCard />
			<JoinCardsList />
			<Grid item container xs={12} display="flex" justifyContent="space-between">
				<BackButton />
				<CreateDataSpaceButton />
			</Grid>
		</NewDataSpacePageContentWrapper>
	);
};

export default DatasetJoinNew;
